// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component, isValidElement, cloneElement } from '../../utils';
import PropTypes from 'prop-types';

const applyParams = (message, params = {}) => {
    const result = [];
    let hasElements = false;
    let m;
    while ((m = message.match(/%%(\w+)%%/))) {
        if (m.index > 0) {
            result.push(message.substr(0, m.index));
        }
        if (params[m[1]] === undefined) {
            result.push(m[0]);
        } else if (isValidElement(params[m[1]])) {
            result.push(cloneElement(params[m[1]], { key: m[1] }));
            hasElements = true;
        } else {
            result.push(params[m[1]]);
        }
        message = message.substr(m.index + m[0].length);
    }
    if (message !== '') {
        result.push(message);
    }
    return hasElements ? result : result.join('');
};

/**
 * LocaleProvider provides a uniform localization support for built-in text of components.
 */
class LocaleProvider extends Component {
    constructor(props) {
        super(props);
        this.lmsg = this.lmsg.bind(this);
    }

    getChildContext() {
        return {
            locale: {
                lmsg: this.lmsg,
            },
        };
    }

    lmsg(key, params = {}, fallback = null) {
        if (typeof key !== 'string') {
            return '';
        }

        let message = this.getMessage(key, this.props.messages);

        if (typeof message !== 'string') {
            message = fallback === null ? `[${key}]` : fallback;
        }

        return applyParams(message, params);
    }

    getMessage(fullKey, messages) {
        const [key, ...rest] = fullKey.split('.');

        if (typeof messages[key] === 'object' && rest.length) {
            return this.getMessage(rest.join('.'), messages[key]);
        }

        return messages[fullKey];
    }

    render() {
        return this.props.children;
    }
}
LocaleProvider.propTypes = {
    /**
     * Localization messages
     */
    messages: PropTypes.object.isRequired,
    children: PropTypes.node,
};
LocaleProvider.defaultProps = {
    children: null,
};

LocaleProvider.childContextTypes = {
    locale: PropTypes.object,
};

export default LocaleProvider;
export {
    applyParams,
};



// WEBPACK FOOTER //
// ./components/LocaleProvider/LocaleProvider.js